/**
 *  检查给定参数是否defined
 */
export function isDefined(d: any) {
  return d !== null && typeof d !== 'undefined'
}
